import React, { useState, useEffect, useRef } from "react";
import {
    Button,
    Card, Collapse, Grid, Typography, Switch, Tooltip
} from "@material-ui/core";
import useStyles from "./styles";

import SearchGrid from "./../../components/table/SearchGrid"
import { GetUserInfo } from "../../Services/GetUserInfo";
import { PostDataAPI } from '../../Services/APIService';
import { InputBaseField } from "./../../components/InputField/InputField";
import { Label, LinkS } from "./../../components/UiElements/UiElements";
import Loader from './../../components/Loader/Loader';
import AddContact from './addContact/AddContact'
import { withSnackbar } from "./../../components/Message/Alert";
import { ActionDialog } from "./../../components/ActionDialog/ActionDialog";
import AddressBookSms from "./../communication/components/sms/AddressBookSms"
import profilePlaceholder from '../../assets/img/profilePlaceholder.jpg';
import SmsIconText from "../../assets/img/action/smsGroupIcon.svg";
import videoFilled from "../../assets/img/action/video-Filled-yellow.svg";
import CallIcon from '../../assets/img/new images/call-icon.svg';
import EditPen from '../../assets/img/action/pen.svg';
import DeleteIcon from '../../assets/img/action/trash.svg';
import NoAddressRecord from '../../assets/img/noAddressRecord.svg';
import { DriveEtaRounded } from "@material-ui/icons";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GoogleLogin } from '@react-oauth/google';
import jwt_decode from 'jwt-decode';
import NotificationsOffIcon from '@material-ui/icons/NotificationsOff';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import GetAppIcon from '@material-ui/icons/GetApp';
import PublishIcon from '@material-ui/icons/Publish';
import { saveActivlityLogInfo } from "./../../components/Common/Extensions";


function AddressBook({ ...props }) {

    const clientId = '85993991486-6offoiqs56u66dfutfru5kt0of6pi7n7.apps.googleusercontent.com';
    const clientSecret = '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';
    const apiKey = 'AIzaSyChz5K-sgDL_0su71kcpqmLi4dGAbh_aRc';
    const discoveryDocs = ['https://www.googleapis.com/discovery/v1/apis/people/v1/rest'];
    const scopes = 'https://www.googleapis.com/auth/contacts.readonly';

    const classes = useStyles();
    const { showMessage } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [addcontactDialog, setAddcontactDialog] = useState(false);
    let user_info = JSON.parse(GetUserInfo());
    const [customerID] = useState(user_info.user.customerID);
    const [accountNumber] = useState(user_info.user.accountNumber);
    const [userType] = useState(user_info.user.userType);
    const [editContact, setEditContact] = useState({});
    const [listAddressBooks, setListAddressBooks] = React.useState([]);
    const [listAddressBooksMain, setListAddressBooksMain] = React.useState([]);
    const [smsDialog, setSmsDialog] = useState(false);

    const [searchValue, setSearchValue] = useState("");
    const [notificationsEnabled, setNotificationsEnabled] = useState(false);

    const [userData, setUserData] = useState([{}]);
    const smsDialogClose = () => {
        setSmsDialog(false)
    }

    const sendSmsOpen = (item) => {
        setUserData(item)
        setSmsDialog(true)
    }
    const onSearchChange = (e) => {
        const { name, value, checked } = e.target;
        let newSearchValue = searchValue.toLowerCase();
        let newToggleValue = notificationsEnabled;

        if (name === 'notificationsEnabled') {
            newToggleValue = checked;
            setNotificationsEnabled(newToggleValue);
        } else {
            newSearchValue = value.toLowerCase();
            setSearchValue(newSearchValue);
        }

        const updatedFilteredData = listAddressBooksMain.filter(entry => {
            const matchesSearch = entry.firstName.toLowerCase().includes(newSearchValue) ||entry.emailAddress.includes(newSearchValue);
            const matchesToggle = newToggleValue ? entry.notificationsEnabled : true;
            return matchesSearch && matchesToggle;
        });

        setListAddressBooks(updatedFilteredData);
    };
    const [customerRecord, setCustomerRecord] = React.useState({});
    const getContactName = (item) => {
        return item?.firstName || item?.emailAddress || item?.phoneNumber || "selected contact";
    };
    const getContactSummary = (item) => {
        const details = [`notify contact ${getContactName(item)}`];
        if (item?.phoneNumber)
            details.push(`phone ${item.phoneNumber}`);
        if (item?.emailAddress)
            details.push(`email ${item.emailAddress}`);
        return details.join(", ");
    };
    const logNotifyContactActivity = (activity, actionText, item) => {
        saveActivlityLogInfo(
            "Notify Contacts",
            activity,
            `User ${actionText} ${getContactSummary(item)}`,
            accountNumber,
            customerID
        );
    };

    //action dialog
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })
    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }
    const handleClose = () => {
        setEditContact({});
        setAddcontactDialog(false)
    }

    const handleSuccessClose = (message) => {
        setEditContact({});
        setAddcontactDialog(false);
        setSmsDialog(false);
        showMessage("Success", message, "success", 3000);
        getCustomerAddressBooks();
    }

    const openContactDialog = () => {
        saveActivlityLogInfo(
            "Notify Contacts",
            "Add Contact Modal Opened",
            "User opened add contact modal",
            accountNumber,
            customerID
        );
        setAddcontactDialog(true)
    }
    const [isUpdate, setIsUpdate] = useState(false);
    const handleUpdate = () => {
        setIsUpdate(!isUpdate);
    }
    const getCustomerAddressBooks = () => {

        var obj = { accountNumber: accountNumber };
        setIsLoading(true);
        PostDataAPI("customer/loadAddressBookGrid", obj).then((result) => {

            if (result.success && result.data != null) {
                var lstAddress = [];
                lstAddress = result.data.map((item, i) => {
                    item.status = item.isFavourite ? "Yes" : 'No';
                    //item.notificationEnabled = item.notificationEnabled === "true" ? true : false;
                    return { ...item }
                });
                setListAddressBooks(lstAddress);
                setListAddressBooksMain(lstAddress);
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);
            handleUpdate();
            //getCustomerProfileDetails();
        });
    }
    const handleActionClick = (key, item) => {
        console.log(customerRecord);
        if (key == 'Edit') {
            logNotifyContactActivity("Edit Contact Modal Opened", "opened edit contact modal for", item);
            setEditContact(item);
            setAddcontactDialog(true)
        } else if (key == 'SMS') {
            logNotifyContactActivity("SMS Modal Opened", "opened SMS modal for", item);
            sendSmsOpen(item);
        }
        else if (key == 'Notification') {
            const enableNotifications = !item.notificationsEnabled;
            logNotifyContactActivity("Auto Notification Confirmation Opened", `opened ${enableNotifications ? "enable" : "disable"} auto-notification confirmation for`, item);
            var message = item.notificationsEnabled ? "Are you sure you want to disable auto-notifications for this contact? This action will prevent the contact from receiving auto-notifications." : "Are you sure you want to enable auto-notifications for this contact? This action will allow the contact to receive auto-notifications.";
            showActionDialog(message, "confirm", function () {
                item.notificationsEnabled = !item.notificationsEnabled;
                const formData = new FormData();
                for (var key in item) {
                    if (item[key] && key != "fileName" && key != "formFile" && key != "encUserID")
                        formData.append(key, item[key]);
                }
                var method = "customer/updateCustomerContact";
                PostDataAPI(method, formData, true, "formData").then((result) => {
                    if (result.success && result.data != null) {
                        logNotifyContactActivity("Auto Notification Updated", `${item.notificationsEnabled ? "enabled" : "disabled"} auto-notifications for`, item);
                        handleSuccessClose(item.notificationsEnabled ? "Auto-notifications for this contact have been successfully enabled." : "Auto-notifications for this contact have been successfully disabled.");
                    }
                    else {
                        showMessage("Error", result.message, "error", 3000);
                    }
                    setIsLoading(false);
                });
            
            });
        }
        else {
            logNotifyContactActivity("Delete Confirmation Opened", "opened delete confirmation for", item);
            showActionDialog("Are you sure you want to delete this contact?", "confirm", function () {
                archiveCustomerContact(item);
            });
        }

    }
    const archiveCustomerContact = (item) => {
        setIsLoading(true);
        PostDataAPI("customer/deleteCustomerContact", item, true).then((result) => {

            if (result.success && result.data != null) {
                logNotifyContactActivity("Contact Deleted", "deleted", item);
                showMessage("Success", "Record deleted successfully", "success", 3000);
                getCustomerAddressBooks();
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);
        });
    }

    const addressBookData = [
        {
            PprofileImage: profilePlaceholder,
            firstName: "John Doe",
            phoneNumber: "202-555-0162",
            emailAddress: "johndoe@gmail.com",
        },
        {
            PprofileImage: profilePlaceholder,
            firstName: "John Doe",
            phoneNumber: "202-555-0162",
            emailAddress: "johndoe@gmail.com",
        },
        {
            PprofileImage: profilePlaceholder,
            firstName: "John Doe",
            phoneNumber: "202-555-0162",
            emailAddress: "johndoe@gmail.com",
        },
        {
            PprofileImage: profilePlaceholder,
            firstName: "John Doe",
            phoneNumber: "202-555-0162",
            emailAddress: "johndoe@gmail.com",
        },
        {
            PprofileImage: profilePlaceholder,
            firstName: "John Doe",
            phoneNumber: "202-555-0162",
            emailAddress: "johndoe@gmail.com",
        },
        {
            PprofileImage: profilePlaceholder,
            firstName: "John Doe",
            phoneNumber: "202-555-0162",
            emailAddress: "johndoe@gmail.com",
        },
    ]
    const formatNumber = (phoneNumber) => {
        return phoneNumber.replace(/\D/g, '');
    }



    const handleLoginSuccess = async (credentialResponse) => {
        const loginDetails = jwt_decode(credentialResponse.credential);
        console.log(loginDetails);
        //try {

        //    //const { accessToken } = credentialResponse;

        //    //// Create an OAuth2 client
        //    //const authClient = new google.auth.OAuth2(clientId, apiKey);
        //    //authClient.setCredentials({ access_token: accessToken });

        //    //// Create a People API client
        //    //const people = google.people({ version: 'v1', auth: authClient });

        //    //// Retrieve the user's contacts
        //    //const { data } = await people.people.connections.list({
        //    //    resourceName: 'people/me',
        //    //    personFields: 'names,emailAddresses',
        //    //});

        //    //// Process the retrieved contacts
        //    //const connections = data.connections || [];
        //    //console.log('Contacts:', connections);
        //} catch (error) {
        //    console.log('Error retrieving contacts:', error);
        //}
    };

    const handleLoginFailure = (error) => {
        console.log('Google login error:', error);
    };

    const responseCallback = (response) => {
        console.log('Google contacts', response);
    };
    const inputFile = useRef(null);
    function handleFileUpload(e) {

        var ext = e.target.files[0].name.match(/\.(.+)$/)[1];

        switch (ext) {
            case 'xlsx':
                break;
            default:
                showMessage("Error", "This file format is not allowed,\n Only Excel files are allowed.", "error", 3000);
                document.getElementById("fileUploadField").value = '';
                return;
        }

        //setAttachment({ file: e.target.files[0] ? e.target.files[0] : null, userFileName: e.target.files[0] ? e.target.files[0].name : null });

        importAddressBook({ file: e.target.files[0] ? e.target.files[0] : null, userFileName: e.target.files[0] ? e.target.files[0].name : null });
        e.target.value = "";
    }
    const handleSelectFile = () => {
        inputFile.current.click();
    };
    const logTemplateDownload = () => {
        saveActivlityLogInfo(
            "Notify Contacts",
            "Template Downloaded",
            "User downloaded notify contacts import template",
            accountNumber,
            customerID
        );
    };
    const importAddressBook = (attachment) => {


        let method = "customer/importAddressBook";

        const formData = new FormData();

        setIsLoading(true);

        formData.append("excelFile", attachment.file);
        formData.append("accountNumber", accountNumber)
        PostDataAPI(method, formData, true, "formData").then((result) => {
            setIsLoading(false);

            if (result.success == true) {

                if (result.success && result.data != null) {
                    showMessage("Success", "Contact imported successfully.", "success", 3000);
                    getCustomerAddressBooks();
                }
            }
            else {
                let errorMessage = result.message.split('.')[0];
                let userID = result.message.split('^')[2];
                if (errorMessage.trim() == 'There are error(s) in excel file') {
                    window.location.assign("." + "\\Documents\\temp\\" + userID + "\\" + result.message.split('^')[1]);
                    showMessage("Error", "There are error(s) in excel file. please review downloaded file for more details.", "error", 3000);
                }
                else
                    showMessage("Error", errorMessage, "error", 3000);
            }
        })

    }
    useEffect(() => {
        getCustomerAddressBooks();
    }, []);

    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            <div className={classes.appBarSpacer} />
            <div className={classes.header}>
                <Typography component="h2">Notify Contacts</Typography>
            </div>
            <Grid className={classes.container}>

                <Grid container style={{ margin: '0px 0px 10px 5px' }}>
                    <Grid item xl={7} md={12} sm={12} xs={12} lg={7}>
                        <div className="d-flex" style={{gap:'10px'}}>
                           
                            <Grid item xl={6} lg={6} md={6} sm={6} xs={12} className={classes.SearchAllign}>
                            <Label title="Search" />
                                <InputBaseField
                                    name="searhTerm"
                                    placeholder="Name/Email"
                                    value={searchValue}
                                    onChange={onSearchChange}
                                    MaxLength={50}
                                    className="align-left"/>
                            </Grid>
                            {userType == "corporate_user" ?
                            <>
                            
                            <Grid item xl={6} lg={6} md={6} sm={6} xs={12} className={classes.SearchAllign}>
                                <Label title="Show Auto-Notification Contacts Only" style={{ marginLeft: '10px' }} />
                                <Switch
                                    disabled={false}
                                    checked={notificationsEnabled}
                                    onChange={onSearchChange}
                                    name="notificationsEnabled"
                                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                                    classes={{
                                        root: classes.root,
                                        switchBase: classes.switchBase,
                                        thumb: classes.thumb,
                                        track: classes.track,
                                        checked: classes.checked,
                                    }}
                                />
                            </Grid>
                                </>:null}
                        </div>
                    </Grid>
                    <Grid item xl={5} md={12} sm={12} xs={12} lg={5} className={classes.AllignCenter }>
                        <LinkS className={classes.changeBtn} style={{ alignItems: 'center', display: 'inline-flex',fontSize:window.isMobileView?  window.isMobile425 ? '8px':'10px':'14px', }} download={"Address_Book_Contacts.xlsx"} href={"." + "\\Documents\\templates\\Address_Book_Contacts.xlsx"} onClick={logTemplateDownload}>
                            <GetAppIcon style={{ marginRight: '6px' }} /> Download Template
                        </LinkS>
                        <Button className={classes.changeBtn} onClick={() => handleSelectFile()}><PublishIcon style={{ marginRight: '6px' }} /> Import</Button>
                        <Button className={classes.changeBtn} onClick={openContactDialog}>Add Contact</Button>
                       {/* <Button className={classes.changeBtn} >Import Contacts</Button>*/}

                        {/*<GoogleOAuthProvider clientId="85993991486-6offoiqs56u66dfutfru5kt0of6pi7n7.apps.googleusercontent.com">*/}
                        {/*    <GoogleLogin*/}
                        {/*        onSuccess={handleLoginSuccess}*/}
                        {/*        onError={handleLoginFailure}*/}
                        {/*    />*/}
                        {/*</GoogleOAuthProvider>*/}
                        {/*<GoogleContacts*/}
                        {/*    clientId={'85993991486-6offoiqs56u66dfutfru5kt0of6pi7n7.apps.googleusercontent.com'}*/}
                        {/*    onSuccess={responseCallback}*/}
                        {/*    onFailure={handleLoginFailure} >*/}
                        {/*</GoogleContacts>*/}
                        {/*<GoogleLogin*/}
                        {/*    clientId={clientId}*/}
                        {/*    onSuccess={handleLoginSuccess}*/}
                        {/*    onFailure={handleLoginFailure}*/}
                        {/*    scope={scopes}*/}
                        {/*    cookiePolicy={'single_host_origin'}*/}
                        {/*    redirectUri="http://localhost:3000"*/}
                        {/*    discoveryDocs={discoveryDocs}*/}
                        {/*/>*/}

                    </Grid>
                </Grid>
                {listAddressBooks.length > 0 ?
                    <Grid container className={classes.addressBookBox}>
                        {
                            listAddressBooks.map((item, i) => {
                                return (
                                    <Grid item sm={6} xs={12} lg={2} md={4} className={classes.addressBox}>
                                        <div className={classes.addressContent}>

                                            <img className="user-address-Book" src={item.photoPath == null ? profilePlaceholder : '.' + item.photoPath} alt="user" />

                                            <h3 style={{ margin: '0px'} }>{item.firstName}</h3>
                                            <h4>{item.phoneNumber}</h4>
                                            <h4 className={"emailLink"}>{item.emailAddress}</h4>
                                            <div className={classes.Icons}>
                                                <Tooltip title={'Send SMS'} placement="right">
                                                    <img src={SmsIconText} className={classes.iconLink} onClick={() => handleActionClick('SMS', item)} />
                                                </Tooltip>
                                                
                                                {userType == "corporate_user" ?
                                                    <Tooltip title={item.notificationsEnabled ? 'Disable auto-notifications' : 'Enable auto-notifications'} placement="right">
                                                        {item.notificationsEnabled ?
                                                            <NotificationsActiveIcon className={classes.iconLink} style={{ color: '#f99300' }} onClick={() => { handleActionClick('Notification', item) }} /> : <NotificationsOffIcon className={classes.iconLink} onClick={() => { handleActionClick('Notification', item) }} />}
                                                    </Tooltip>
                                                    : <img src={videoFilled} className={classes.iconLink} />}
                                                {window.isIpadView ?
                                                    <a href={"tel:" + formatNumber(item.phoneNumber)}> <img src={CallIcon} className={classes.iconLink} /> </a>
                                                    : ''}
                                                <Tooltip title={'Edit contact'} placement="right">
                                                    <img src={EditPen} className={classes.iconLink} onClick={() => { handleActionClick('Edit', item) }} />
                                                </Tooltip>
                                                <Tooltip title={'Delete contact'} placement="right">
                                                    <img src={DeleteIcon} className={classes.iconLink} onClick={() => { handleActionClick('Delete', item) }} />
                                                </Tooltip>
                                            </div>
                                        </div>
                                    </Grid>)

                            })
                        }


                    </Grid> :
                    <Grid container className={classes.addressBookNoRecord}>
                        <Grid item sm={12} xs={12} lg={12} md={12} >
                            <img src={NoAddressRecord} />
                            <h3>No contacts found</h3>
                        </Grid>
                    </Grid>
                }

            </Grid>
            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />
            {addcontactDialog ? <AddContact
                dialogOpenClose={addcontactDialog}
                handleClose={handleClose}
                handleSuccessClose={handleSuccessClose}
                objAddress={editContact}
                accountNumber={accountNumber}
                accountPhoneNumber={customerRecord?.accountPhoneNumber}
            ></AddContact> : ''}

            {smsDialog ?
                <AddressBookSms
                    dialogOpenClose={smsDialog}
                    handleClose={smsDialogClose}
                    handleSuccessClose={handleSuccessClose}
                    userData={userData}
                ></AddressBookSms> : ''}
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>

                <form>
                    <div>
                        <input ref={inputFile} style={{ display: "none" }} type="file" id="fileUploadField" onChange={handleFileUpload} accept=".xlsx,.xls,.xlsm" />
                    </div>
                </form>
            </Grid>

        </>
    )
}
export default withSnackbar(AddressBook);
